export default "__VITE_ASSET__0ba65286__"